import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from '@/plugins/vuetify';
import "@/assets/css/styles.min.css"; // Import Icons8 Font Library CSS file
import mixin from './mixins/';
import IdleVue from "idle-vue";


//service worker for updates
import VueOffline from 'vue-offline'

Vue.use(VueOffline, {
  mixin: true
})

Vue.mixin(mixin);

//lodash
import _ from "lodash-es";
import orderBy from "lodash-es/orderBy";
import find from "lodash-es/find";
Vue.prototype.$_ = _;
Vue.prototype.$orderBy = orderBy;
Vue.prototype.$find = find;

// moment.js library for dates
import moment from "moment";
Vue.prototype.$moment = moment;

//notifications
import Snotify from 'vue-snotify'; 
Vue.use(Snotify);

Vue.config.productionTip = false;

//firebase import
const firebase = require("./firebase/firebase-config.js");
Vue.prototype.$firebase = firebase; // this.$firebase to access all across components

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 2400000,
  startAtIdle: false
});